module.exports = __webpack_public_path__ + "static/media/airco.c3540e62.png";